/* fd-countdown — compte à rebours de la barre Black Friday (sections/fd-countdown.liquid).
   Temps restant jusqu'au prochain lundi 0 h, heure de Berlin : il repart de 7 jours chaque lundi à minuit. */
(function () {
  var fmt = null;
  try {
    fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  } catch (e) { fmt = null; }
  var JOURS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function restant() {
    var d = new Date(), j, h, m, s;
    if (fmt) {
      var p = {};
      fmt.formatToParts(d).forEach(function (x) { p[x.type] = x.value; });
      j = JOURS[p.weekday]; h = parseInt(p.hour, 10) % 24; m = parseInt(p.minute, 10); s = parseInt(p.second, 10);
    } else {
      j = d.getDay(); h = d.getHours(); m = d.getMinutes(); s = d.getSeconds();
    }
    var jours = (8 - j) % 7;
    if (jours === 0) jours = 7;
    var r = jours * 86400 - (h * 3600 + m * 60 + s);
    return r > 0 ? r : r + 7 * 86400;
  }

  function deux(n) { return (n < 10 ? '0' : '') + n; }

  function tic() {
    var r = restant();
    var v = [Math.floor(r / 86400), Math.floor((r % 86400) / 3600), Math.floor((r % 3600) / 60), r % 60];
    document.querySelectorAll('[data-fd-countdown]').forEach(function (t) {
      var n = t.querySelectorAll('[data-cd]');
      for (var i = 0; i < 4 && i < n.length; i++) n[i].textContent = deux(v[i]);
    });
  }

  tic();
  setInterval(tic, 1000);
})();
